import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class DissolvedOxygenSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.DissolvedOxygenSensor,
    });
  }
}
